module.exports = __webpack_public_path__ + "img/5-2.c76b5f72.png";